"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateOnlyStringOf = exports.convertQuebecDateToUtcDateString = exports.convertUtcDateToQuebecDateString = exports.convertDateStringToQuebecTimezone = exports.hasAge = exports.isValidDate = exports.formatDateToIsoString = exports.getTimerValues = exports.renderTime = exports.getUtcTimeNow = exports.QUEBEC_TIMEZONE_OFFSET_IN_HOURS = void 0;
exports.QUEBEC_TIMEZONE_OFFSET_IN_HOURS = -4;
function getUtcTimeNow() {
    return new Date(new Date().toUTCString()).getTime();
}
exports.getUtcTimeNow = getUtcTimeNow;
function renderTime(timeInMs) {
    const { minutes, paddedSeconds } = getTimerValues(timeInMs);
    return [minutes, paddedSeconds].join(':');
}
exports.renderTime = renderTime;
function getTimerValues(timeInMs) {
    const fallbackValues = {
        isRed: false,
        minutes: '-',
        paddedSeconds: '--',
    };
    if (typeof timeInMs !== 'number' || Number.isNaN(timeInMs)) {
        return fallbackValues;
    }
    if (timeInMs <= 0)
        return { isRed: true, minutes: '0', paddedSeconds: '00' };
    const totalSeconds = Math.floor(timeInMs / 1000);
    const minutes = Math.abs(Math.floor(totalSeconds / 60));
    const isRed = totalSeconds < 10;
    if (minutes >= 10)
        return { ...fallbackValues, isRed };
    const seconds = Math.abs(totalSeconds % 60);
    const paddedSeconds = seconds.toString().padStart(2, '0'); // Add leading zero
    return {
        isRed,
        minutes: String(minutes),
        paddedSeconds,
    };
}
exports.getTimerValues = getTimerValues;
function formatDateToIsoString(date) {
    if (!isValidDate(date))
        return;
    return new Date(date).toISOString().split('T')[0];
}
exports.formatDateToIsoString = formatDateToIsoString;
function isValidDate(dateStr) {
    return !Number.isNaN(new Date(dateStr).getTime());
}
exports.isValidDate = isValidDate;
function hasAge(options) {
    const dateOfBirth = new Date(options.dateOfBirth);
    const atGivenDate = options.atGivenDate ? new Date(options.atGivenDate) : new Date();
    if (!isValidDate(dateOfBirth) || !isValidDate(atGivenDate))
        return;
    const ageLimitDate = new Date(atGivenDate.getFullYear() - options.yearsOld, atGivenDate.getMonth(), atGivenDate.getDate());
    return dateOfBirth <= ageLimitDate;
}
exports.hasAge = hasAge;
function convertDateStringToQuebecTimezone(dateString) {
    // Parse the input date (assumed to be in UTC)
    const dateOnlyString = dateString.substring(0, 10);
    const offset = exports.QUEBEC_TIMEZONE_OFFSET_IN_HOURS;
    const pad = (num) => `${String(num).length === 1 ? '0' : ''}${num}`;
    const offsetString = `${offset < 0 ? '-' : '+'}${pad(Math.abs(offset))}:00`;
    return `${dateOnlyString}T00:00:00.000${offsetString}`;
}
exports.convertDateStringToQuebecTimezone = convertDateStringToQuebecTimezone;
/**
 * @example
 * const todayDateString = convertUtcDateToQuebecDateString(new Date()) // 2025-03-25
 */
function convertUtcDateToQuebecDateString(utcDate) {
    if (!isValidDate(utcDate))
        return;
    const offset = exports.QUEBEC_TIMEZONE_OFFSET_IN_HOURS * 60 * 60 * 1000;
    return new Date(new Date(utcDate).getTime() - offset).toISOString().substring(0, 10);
}
exports.convertUtcDateToQuebecDateString = convertUtcDateToQuebecDateString;
function convertQuebecDateToUtcDateString(quebecDate) {
    if (!isValidDate(quebecDate))
        return;
    const offset = exports.QUEBEC_TIMEZONE_OFFSET_IN_HOURS * 60 * 60 * 1000;
    return new Date(new Date(quebecDate).getTime() + offset).toISOString().substring(0, 10);
}
exports.convertQuebecDateToUtcDateString = convertQuebecDateToUtcDateString;
/**
 * Returns the current ISO date string without time
 * @example
 * const dateOnly = getDateOnlyStringOf(new Date())
 * // '2025-03-19'
 */
function getDateOnlyStringOf(date) {
    return new Date(date).toISOString().substring(0, 10);
}
exports.getDateOnlyStringOf = getDateOnlyStringOf;
//# sourceMappingURL=index.js.map